import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HeroCard, HeroCardMode } from '@gains-com/shared';
import { environment } from '../../../environments/environment';
import { catchError, map, of, take } from 'rxjs';
import { Observable } from 'rxjs';

interface HeroCardsResponse {
  count: number;
  data: HeroCard[];
}

@Injectable({
  providedIn: 'root',
})
export class HeroCardsService {

  private readonly _http = inject(HttpClient);

  listHeroCards(mode: HeroCardMode): Observable<HeroCard[]> {
    return this._http
      .get<HeroCardsResponse>(`${environment.apiUrl}/hero-cards`, {
        params: { mode },
        transferCache: false
      })
      .pipe(
        take(1),
        map(response => response.data),
        catchError(err => {
          console.error('Error fetching hero cards:', err);
          return of([]);
        })
      );
  }
}
